import { menuToRoutes, eachTreeData } from 'ele-admin';
import { HOME_PATH, LAYOUT_PATH, REDIRECT_PATH } from '@/config/setting';
import EleLayout from '@/layout/index.vue';
import RedirectLayout from '@/components/RedirectLayout';
import { iframeMixins } from '@/utils/iframe-mixin';

const XINGZHENG_ROUTES = [
  { path: '/xingzheng', redirect: '/xingzheng/dashboard', title: '行政管理' },
  { path: '/xingzheng/dashboard', title: '看板' },
  { path: '/xingzheng/employees', title: '员工档案' },
  { path: '/xingzheng/archive', title: '文件归档' },
  { path: '/xingzheng/events', title: 'BSG 大事记', alias: '/xingzheng/milestones' },
  { path: '/xingzheng/album', title: 'BSG 照片集' },
  { path: '/xingzheng/safety', title: '安全检查' },
  { path: '/xingzheng/travel', title: '出差记录' },
  { path: '/xingzheng/anniversary', title: '周年纪念' },
  { path: '/xingzheng/birthday', title: '生日管理' },
  { path: '/xingzheng/attrition', title: '离职管理' },
  { path: '/xingzheng/sync', title: '钉钉同步' }
];

/**
 * 静态路由
 */
export const routes = [
  {
    path: '/login',
    component: () => import('@/views/login'),
    meta: { title: '登录' }
  },
  {
    path: '/sso/callback',
    component: () => import('@/views/login'),
    meta: { title: 'SSO 登录' }
  },
  {
    path: '/login-success',
    redirect: HOME_PATH || '/xingzheng/dashboard'
  },
  {
    path: '/forget',
    component: () => import('@/views/forget'),
    meta: { title: '忘记密码' }
  },
  {
    path: '/preview/customer-ops-dashboard',
    component: () => import('@/views/preview/customer-ops-dashboard/index.vue'),
    meta: { title: '客服运营看板预览' }
  },
  {
    path: '/xingzheng',
    component: EleLayout,
    redirect: '/xingzheng/dashboard',
    children: getXingzhengStaticRoutes()
  }
];

/**
 * 添加动态路由
 * @param menus 菜单数据
 * @param homePath 菜单数据的第一个页面地址
 */
export function getMenuRoutes(menus, homePath) {
  const routes = [
    // 用于刷新的路由
    {
      path: REDIRECT_PATH + '/:path(.*)',
      component: RedirectLayout,
      meta: { hideFooter: true }
    }
  ];
  // 路由铺平处理
  eachTreeData(
    menuToRoutes(menus, getComponent, [], null, null, iframeMixins),
    (route) => {
      routes.push({ ...route, children: null });
    }
  );
  if (hasXingzhengMenu(menus)) {
    XINGZHENG_ROUTES.forEach((item) => {
      if (!routes.some((route) => route.path === item.path)) {
        routes.push({
          path: item.path,
          alias: item.alias,
          component: item.redirect ? undefined : getComponent('xingzheng/index'),
          redirect: item.redirect,
          meta: {
            title: item.title
          }
        });
      }
    });
  }
  routes.push({
    path: '*',
    component: () => import('@/views/exception/404')
  });
  return {
    path: LAYOUT_PATH,
    component: EleLayout,
    redirect: HOME_PATH ?? homePath,
    children: routes
  };
}

/**
 * 获取路由组件
 * @param component 组件名称
 */
function getComponent(component) {
  if (component) {
    return () => import('@/views/' + component);
  }
}

function getXingzhengStaticRoutes() {
  return XINGZHENG_ROUTES.map((item) => ({
    path: item.path === '/xingzheng' ? '' : item.path.replace('/xingzheng/', ''),
    alias: item.alias,
    component: item.redirect ? undefined : getComponent('xingzheng/index'),
    redirect: item.redirect,
    meta: {
      title: item.title
    }
  }));
}

function hasXingzhengMenu(menus) {
  let matched = false;
  eachTreeData(menus, (menu) => {
    if (menu.path === '/xingzheng' || menu.path?.startsWith('/xingzheng/')) {
      matched = true;
      return false;
    }
  });
  return matched;
}
